<template>
  <div>
    <v-dialog
      v-model="open"
      persistent
    >
      <v-card>
        <v-card-title>
          <div class="title text-xs-center">
            <i class="material-icons icon">language</i>
          </div>

          <luci-btn-icon :config="exitBtnConfig" @callback="$emit('close')" class="exit-btn"></luci-btn-icon>
        </v-card-title>

        <div class="modal-content pt-4 pb-3 pl-3 pr-3">
          <v-alert v-if="translationError" :value="true" color="error" icon="error" class="error-container">
            <span class="error-span luci-text white--text">{{ translationError }}</span>
          </v-alert>

          <div v-if="translationLoading" class="loading">
            <img src="../../assets/images/icons/loading-pmc.gif" alt="'Loading">
          </div>

          <div v-if="!translationLoading && !success">
            <luci-form
              :config="formConfig"
              v-model="formData"
              @submit="saveForm"
              @reset="resetForm"
              @callback="cancelButton">
            </luci-form>
          </div>

          <div v-if="!translationLoading && success" class="pt-5">
            <h3 class="luci-subtitle text-xs-center">Successfully changed!</h3>
            <v-card-actions>
              <div class="actions text-xs-center">
                <div class="action-btn">
                  <luci-btn-icon :config="closeBtnConfig" @callback="cancelButton"></luci-btn-icon>
                  <div class="close-btn-text">close</div>
                </div>
              </div>
            </v-card-actions>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import variables from '../../helpers/variables'

export default {
  name: 'TranslationModal',
  props: {
    open: { type: Boolean },
    item: Object
  },
  computed: {
    ...mapGetters({
      translationLoading: 'category/update/translationLoading',
      translationError: 'category/update/translationError',
      translation: 'category/update/translation'
    }),
    formData: {
      get () {
        return this.translation ? this.translation : { description: '' }
      },
      set (value) {
        this.updateTranslation(value)
      }
    },
    formConfig () {
      return (
        {
          name: 'form-translate-category',
          title: this.item ? `${this.item.name} Translation` : 'Translation',
          description: 'Fill in the correct details below.',
          showButtonAsIcon: true,
          buttons: variables.formBtnIconOptions,
          fields: [
            {
              order: 1,
              element: 'input',
              required: true,
              name: 'name',
              label: 'name',
              inputConfig: { placeholder: 'Please enter category name', clearable: true }
            },
            {
              order: 2,
              element: 'textarea',
              required: true,
              name: 'description',
              label: 'description',
              textareaConfig: { placeholder: 'Please enter category description', clearable: true }
            }
          ]
        }
      )
    }
  },
  data () {
    return {
      success: false,
      closeBtnConfig: {
        type: 'button',
        name: 'close-btn',
        primary: true,
        icon: true,
        iconType: 'thumb_up',
        tooltip: 'Close'
      },
      exitBtnConfig: variables.exitBtnIconConfigOptions
    }
  },
  methods: {
    ...mapActions({
      getTranslation: 'category/update/getTranslation',
      storeTranslation: 'category/update/storeTranslation',
      updateTranslation: 'category/update/updateTranslation'
    }),
    saveForm () {
      this.storeTranslation(this.item.code).then(() => {
        this.success = true
      })
    },
    resetForm () {
      this.getTranslation(this.item.code)
    },
    cancelButton () {
      this.success = false
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/modal';

  @include translate-modal;
</style>
